import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    const messages = [];

    if (!props.title && !props.embedUrl) {
        messages.push("Module is missing a title.");
    }

    if (!props.subtitle && !props.embedUrl) {
        messages.push("Module is missing a subtitle.");
    }

    return messages;
}
